import { render, staticRenderFns } from "./OCRadioGroup.html?vue&type=template&id=ceecc7a4&scoped=true&"
import script from "./OCRadioGroup.ts?vue&type=script&lang=ts&"
export * from "./OCRadioGroup.ts?vue&type=script&lang=ts&"
import style0 from "./OCRadioGroup.css?vue&type=style&index=0&id=ceecc7a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceecc7a4",
  null
  
)

export default component.exports